/*
All form fields:

   'title'
   'event_category'
   'description'
   'address'
   'pre_requisite_event'
   'thumbnail'
   'cover'
    -------------------------
   'grades'
   'course_topics'
    -------------------------
   'register_date'
   'register_end_date'
   'event_date'
   'event_end_date'
   'dates_description'
    -------------------------
   'has_agent'
   'agent_share'
    -------------------------
   'approved_students'
   'approval_criteria_percent'
   'approval_criteria_per_province'
    -------------------------
   'appreciation_letter_students'
   'appreciation_letter_criteria_percent'
   'appreciation_letter_criteria_per_province'
    -------------------------
   'registered_students'
    -------------------------
   'event_tickets'
   'event_extensions'
   --------------------------
   'contest_id'
*/

export const processEventFormData = (values, formData) => {
  // ────────────────────────────────────────────────────────────────────────────────

  formData.append('title', values.title)
  // formData.append('event_category', values.event_category)
  if(isDefined(values.description)) formData.append('description', values.description)
  if(isDefined(values.address)) formData.append('address', values.address)

  if (values.pre_requisite_event)
    formData.append('pre_requisite_event', values.pre_requisite_event.id)

  formData.append('grades', values.grades)

  if (values.course_topics) formData.append('course_topics', values.course_topics)

  if (values.thumbnail && !(typeof values.thumbnail === 'string')) {
    formData.append(
      'thumbnail',
      values.thumbnail ? (values.thumbnail.length > 0 ? values.thumbnail[0] : null) : null
    )
  }

  if (values.cover && !(typeof values.cover === 'string')) {
    formData.append(
      'cover',
      values.cover ? (values.cover.length ? values.cover[0] : null) : null
    )
  }

  // ────────────────────────────────────────────────────────────────────────────────

  if (values.badge_template)
    formData.append('badge_template', values.badge_template.id)

  if (values.certificate_template)
    formData.append('certificate_template', values.certificate_template.id)

  if (values.appreciation_template)
    formData.append('appreciation_template', values.appreciation_template.id)

  // ────────────────────────────────────────────────────────────────────────────────

  if(isDefined(values.register_date))
    formData.append('register_date', values.register_date)

  if(isDefined(values.register_end_date))
    formData.append('register_end_date', values.register_end_date)

  if(isDefined(values.event_date))
    formData.append('event_date', values.event_date)

  if(isDefined(values.event_end_date))
    formData.append('event_end_date', values.event_end_date)

  if(isDefined(values.dates_description))
    formData.append('dates_description', values.dates_description)

  // ────────────────────────────────────────────────────────────────────────────────

  formData.append('has_agent', values.has_agent)
  if (values.has_agent && values.has_agent !== 'false') formData.append('agent_share', values.agent_share)

  // ────────────────────────────────────────────────────────────────────────────────

  if (values.approved_students && values.approved_students.length)
    formData.append('approved_students', values.approved_students[0])

  if (values.approval_criteria_percent)
    formData.append('approval_criteria_percent', values.approval_criteria_percent)

  if ( isDefined(values.approval_criteria_per_province) ) {
    const valueToBoolean =
      Array.isArray(values.approval_criteria_per_province) && !values.approval_criteria_per_province.length
      ? false : values.approval_criteria_per_province

    formData.append('approval_criteria_per_province', valueToBoolean)
  }

  // ────────────────────────────────────────────────────────────────────────────────

  if (values.appreciation_letter_students && values.appreciation_letter_students.length) {
    formData.append(
      'appreciation_letter_students',
      values.appreciation_letter_students[0]
    )
  }

  if (values.appreciation_letter_criteria_percent) {
    formData.append(
      'appreciation_letter_criteria_percent',
      values.appreciation_letter_criteria_percent
    )
  }

  if ( isDefined(values.appreciation_letter_criteria_per_province) ) {
    const valueToBoolean =
      Array.isArray(values.appreciation_letter_criteria_per_province)
        && !values.appreciation_letter_criteria_per_province.length
      ? false : values.appreciation_letter_criteria_per_province

    formData.append(
      'appreciation_letter_criteria_per_province',
      valueToBoolean
    )
  }

  // ────────────────────────────────────────────────────────────────────────────────

  if (values.registered_students && values.registered_students.length)
    formData.append('registered_students', values.registered_students)

  // ────────────────────────────────────────────────────────────────────────────────

  if (values.event_tickets && values.event_tickets.length)
    formData.append('event_tickets', JSON.stringify(values.event_tickets))

  if (values.event_extensions && values.event_extensions.length)
    formData.append('event_extensions', JSON.stringify(values.event_extensions))

  // ────────────────────────────────────────────────────────────────────────────────

  if (isDefined(values.contest_id)) formData.append('contest_id', values.contest_id)
}

export const processEventTicketAndExtensions = (rawValues, formData) => {
  if(rawValues.tickets)
    formData.append('tickets', JSON.stringify(rawValues.tickets))

  if(rawValues.extensions)
    formData.append('extensions', JSON.stringify(rawValues.extensions))
}

// ────────────────────────────────────────────────────────────────────────────────

export const formatOptionsList = options =>
  options.map(({ id, name: title }) => ({ id, title }))

// ────────────────────────────────────────────────────────────────────────────────

const castBooleanToString = bool => (bool !== null && bool !== undefined? bool.toString() : 'false')

// ────────────────────────────────────────────────────────────────────────────────

export function processEventInitialValues(event) {
  const changes = {
    // event_category: event.event_category.id,

    // pre_requisite_event: event.pre_requisite_event
    //   ? event.pre_requisite_event
    //   : undefined,

    has_agent: castBooleanToString(event.has_agent),

    approval_criteria_per_province: castBooleanToString(
      event.approval_criteria_per_province
    ),

    appreciation_letter_criteria_per_province: castBooleanToString(
      event.appreciation_letter_criteria_per_province
    ),
  }

  return { ...event, ...changes }
}

const isDefined = (variable) => variable !== undefined

const appendToFormDataIfDefined = (key, value, formData) => {
  if (isDefined(value)) formData.append(key, value)

  return formData
}


// WEBPACK FOOTER //
// ./src/components/common/events/eventFormUtil.js